import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

export class AjaxCustomComponentLoader extends Component {
    private readonly loadComponentEvent = "AjaxCustomComponentLoaderEvent";

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);

        element.addEventListener(this.loadComponentEvent,
            ev => this.handleEvent(ev, context));

    }


    private handleEvent(ev: Event, pc: PageContext): void {

        ReloadComponents("read-more-wrapper", pc);

    }
}

ComponentFactory.registerComponent("AjaxCustomComponentLoader", AjaxCustomComponentLoader);

async function ReloadComponents(elemId: string, _pageContext: PageContext) {
    let targetElem = document.getElementById(elemId);
    if (targetElem === null || targetElem === undefined)
        return;
    await _pageContext?.componentFactory.loadComponents(targetElem)
}
